import { render, staticRenderFns } from "./UnidadesList.vue?vue&type=template&id=ba8347d2&scoped=true"
import script from "./UnidadesList.vue?vue&type=script&lang=js"
export * from "./UnidadesList.vue?vue&type=script&lang=js"
import style0 from "./UnidadesList.vue?vue&type=style&index=0&id=ba8347d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8347d2",
  null
  
)

export default component.exports